import { getTelHref } from '@/utils/phone-number'

import { URL_SCHEME_REGEX } from './field-row.constants'
import type { FieldExternalLinkProps } from './field-row.types'

export const getExternalHref = (kind: FieldExternalLinkProps['kind'], value: string) => {
  if (kind === 'email') {
    return `mailto:${value}`
  }

  if (kind === 'phone') {
    return getTelHref(value)
  }

  return URL_SCHEME_REGEX.test(value) ? value : `https://${value}`
}
